import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FiMail, FiMapPin, FiShield, FiUser } from "react-icons/fi";
import { getAdminDetails } from "../services/profileService";
import "./ViewProfileLayer.css";

const DEFAULT_IMG = "assets/images/user-grid/user-grid-img13.png";

const ViewProfileLayer = () => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const res = await getAdminDetails();
      if (res?.status === "Active") {
        const data = res.profile || {};
        setProfile({
          name: data.teacher_name || data.name || "N/A",
          email: data.email || "N/A",
          password: data.password || "********",
          address: data.address || "Not Provided",
          image: data.logo_url || data.photo || "",
          role: data.role || "School Admin",
          status: res.status,
        });
      }
    } catch {
      toast.error("Failed to load profile");
    }
  };

  if (!profile) {
    return (
      <div className="profile-loading-wrap">
        <div className="profile-loader" />
      </div>
    );
  }

  return (
    <section className="profile-page-shell">
      <div className="profile-hero-card">
        <div className="profile-hero-pattern" />

        <div className="profile-hero-content">
          <div className="profile-avatar-ring">
            <img
              src={profile.image || DEFAULT_IMG}
              alt="Profile"
              className="profile-main-avatar"
              onError={(event) => {
                event.target.src = DEFAULT_IMG;
              }}
            />
          </div>

          <div className="profile-hero-text">
            <p className="profile-kicker">Profile Overview</p>
            <h1>{profile.name}</h1>
            <p className="profile-subtitle">{profile.email}</p>

            <div className="profile-badges-row">
              <span className="profile-badge">{profile.role}</span>
              <span className="profile-badge success">{profile.status}</span>
            </div>
          </div>
        </div>

        <div className="profile-metrics">
          <div className="metric-card">
            <span>Role</span>
            <strong>{profile.role}</strong>
          </div>
          <div className="metric-card">
            <span>Status</span>
            <strong>{profile.status}</strong>
          </div>
          <div className="metric-card">
            <span>Address</span>
            <strong>{profile.address}</strong>
          </div>
        </div>
      </div>

      <div className="profile-grid-layout">
        <article className="profile-panel profile-summary-panel">
          <div className="panel-heading">
            <h4>Contact & Access</h4>
          </div>

          <div className="summary-stack">
            <div className="summary-item">
              <span className="summary-icon">
                <FiUser />
              </span>
              <div>
                <label>Profile Name</label>
                <strong>{profile.name}</strong>
              </div>
            </div>

            <div className="summary-item">
              <span className="summary-icon">
                <FiMail />
              </span>
              <div>
                <label>Email Address</label>
                <strong>{profile.email}</strong>
              </div>
              <button
                type="button"
                className="copy-btn"
                onClick={() => {
                  navigator.clipboard.writeText(profile.email || "");
                  toast.success("Email copied");
                }}
              >
                Copy
              </button>
            </div>

            <div className="summary-item">
              <span className="summary-icon">
                <FiMapPin />
              </span>
              <div>
                <label>Address</label>
                <strong>{profile.address}</strong>
              </div>
            </div>

            <div className="summary-item">
              <span className="summary-icon">
                <FiShield />
              </span>
              <div>
                <label>Access Password</label>
                <strong>{profile.password}</strong>
              </div>
              <button
                type="button"
                className="copy-btn"
                onClick={() => {
                  navigator.clipboard.writeText(profile.password || "");
                  toast.success("Password copied");
                }}
              >
                Copy
              </button>
            </div>
          </div>
        </article>

        <article className="profile-panel profile-details-panel">
          <div className="panel-heading">
            <h4>Profile Details</h4>
          </div>

          <div className="details-grid">
            <div className="detail-card">
              <span>Name</span>
              <strong>{profile.name}</strong>
            </div>

            <div className="detail-card">
              <span>Email</span>
              <strong>{profile.email}</strong>
            </div>

            <div className="detail-card">
              <span>Password</span>
              <strong>{profile.password}</strong>
            </div>

            <div className="detail-card detail-card-wide">
              <span>Address</span>
              <strong>{profile.address}</strong>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default ViewProfileLayer;
